import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import ConfirmWeekDialog from "./ConfirmWeekDialog";
import ConfirmDialog from "./ExtendPlanModal"; // ✅ reused as ConfirmDialog
import { ProgramContext } from "../../context/ProgramsContext";
import { useLocation } from "react-router-dom";

export default function ProgramWeeksInput({
    value,
    onChange,
    disabled = false,
    plan,
    setPlan,
    setHeaderData,
    executeAddWeek,
    loadingProgram,
    ...props
}) {
    const { isPast, programId, isTemplate } = useContext(ProgramContext);
    const [tempLength, setTempLength] = useState(value);
    const [showDialog, setShowDialog] = useState(false);
    const [dialogType, setDialogType] = useState("");
    const [pendingAction, setPendingAction] = useState(null);
    const [extendModalOpen, setExtendModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [pendingNewLength, setPendingNewLength] = useState(null);
    const [newLength, setNewLength] = useState(0)
    // const [maxDisabledWeek, setMaxDisabledWeek] = useState(0)
    const location = useLocation();

    useEffect(() => {
        setTempLength(value);
    }, [value]);

    // useEffect(() => {
    //     if (!loadingProgram && programId && !isTemplate) {
    //         const thisMaxDisabledWeek = parseInt(localStorage.getItem("maxDisabledWeek"))
    //         console.log("thisMaxDisabledWeek", thisMaxDisabledWeek)
    //         setMaxDisabledWeek(thisMaxDisabledWeek)
    //     } else if (isTemplate) {
    //         setMaxDisabledWeek(0)
    //     }
    // }, [loadingProgram])

    const checkIsWeekInPastWithTasks = (week) => {
        return week.days.some(day => {
            const isPastDay = isPast(day.date);
            const hasImportantActivity = day.activities.some(
                (a) => a.is_complete || a.is_skipped || a.is_incomplete
            );
            return (isPastDay && day.activities.length > 0) || hasImportantActivity;
        });
    };

    const weekContainsTasks = (week) => {
        return week.days.some(day => day.activities.length > 0);
    };

    const handleConfirm = () => {
        setShowDialog(false);
        if (pendingAction) pendingAction(plan.weeks.length - newLength);
    };


    const handleCancel = () => {
        setShowDialog(false);
        setPendingAction(null);
        setTempLength(plan?.weeks?.length)
    };

    const deleteLastWeek = (weeksToRemove = 1) => {
        setPlan(prev => {
            const newPlan = JSON.parse(JSON.stringify(prev));
            const trimmedWeeks = newPlan.weeks.slice(0, newPlan.weeks.length - weeksToRemove);

            const reNumbered = trimmedWeeks.map((w, idx) => ({ ...w, weekNumber: idx + 1 }));
            setHeaderData(h => ({ ...h, planLength: reNumbered.length }));
            onChange(reNumbered.length);

            return { ...newPlan, weeks: reNumbered };
        });
    };

    // const deleteTillPossible = () => {

    //     const lockedWeeks = plan.weeks.filter(week =>
    //         week.days.some(day => day.activities.length > 0)
    //     );

    //     const greatestLockedWeekNumber = lockedWeeks.reduce((max, week) => {
    //         return week.weekNumber > max ? week.weekNumber : max;
    //     }, 0);

    //     if (newLength < greatestLockedWeekNumber) {
    //         setPlan(prev => {
    //             const newPlan = JSON.parse(JSON.stringify(prev));
    //             let trimmedWeeks = [...newPlan.weeks];

    //             while (trimmedWeeks.length > newLength) {
    //                 const lastWeek = trimmedWeeks[trimmedWeeks.length - 1];
    //                 const hasTasks = lastWeek.days.some(day => day.activities.length > 0);
    //                 if (hasTasks) break;
    //                 trimmedWeeks.pop();
    //             }

    //             // Update week numbers
    //             trimmedWeeks = trimmedWeeks.map((w, idx) => ({
    //                 ...w,
    //                 weekNumber: idx + 1
    //             }));

    //             // Sync actual planLength after trimming
    //             setHeaderData(h => ({ ...h, planLength: trimmedWeeks.length }));
    //             setTempLength(trimmedWeeks.length);

    //             return {
    //                 ...newPlan,
    //                 weeks: trimmedWeeks
    //             };
    //         });
    //     }
    // };


    const confirmExtendPlan = () => {
        setExtendModalOpen(false);
        if (pendingNewLength != null) {
            const currentLength = plan.weeks.length;
            const weeksToAdd = pendingNewLength - currentLength;

            for (let i = 0; i < weeksToAdd; i++) {
                executeAddWeek();
            }

            setHeaderData(h => ({ ...h, planLength: pendingNewLength }));
            onChange(pendingNewLength);
            setPendingNewLength(null);
        }
    };


    const confirmReducePlan = () => {
        setDeleteModalOpen(false);
        if (pendingNewLength != null) {
            const currentLength = plan.weeks.length;
            const weeksToRemove = currentLength - newLength;
            deleteLastWeek(weeksToRemove);
            setPendingNewLength(null);
        }
    };

    const manualChangeWeeks = (newLength) => {

        const currentLength = plan.weeks.length;
        newLength = parseInt(newLength);
        if (newLength === 0 && currentLength === 0) {
            return;
        }
        if (isNaN(newLength)) {
            toast.dismiss()
            toast.error(`Length must be a number.`);
            setTempLength(currentLength)
            return;
        }
        if (isNaN(newLength) || newLength < 0) {
            toast.dismiss()
            toast.error(`Length cannot be less than 0.`);
            setTempLength(currentLength)
            return;
        }
        if (newLength < (isTemplate ? 0 : !programId ? 0 : parseInt(localStorage.getItem("maxDisabledWeek") || 0))) {
            toast.dismiss()
            toast.error(`First ${(isTemplate ? 0 : !programId ? 0 : parseInt(localStorage.getItem("maxDisabledWeek") || 0))} weeks cannot be deleted.`)
            setTempLength(currentLength)
            return;
        }
        setNewLength(newLength)

        if (newLength < currentLength) {
            const currentLength = plan.weeks.length;
            const weeksToRemove = currentLength - newLength;
            const weeksBeingRemoved = plan.weeks.slice(-weeksToRemove);

            const anyBlocked = weeksBeingRemoved.some(week => checkIsWeekInPastWithTasks(week));
            const anyWithTasks = weeksBeingRemoved.some(week => weekContainsTasks(week));

            if (anyBlocked) {
                setTempLength(currentLength);
                setHeaderData(h => ({ ...h, planLength: currentLength }));
                // setPendingAction(() => deleteTillPossible);
                // setNewLength(newLength);
                setDialogType("block");
                setShowDialog(true);
                return;
            } else if (anyWithTasks) {
                setDialogType("confirm");
                setPendingAction(() => deleteLastWeek);
                setNewLength(newLength); // pass this on confirm
                setShowDialog(true);
                return;
            } else {
                setPendingNewLength(newLength);
                setDeleteModalOpen(true);
                return;
            }

            // delete directly if safe
            deleteLastWeek(weeksToRemove);
            return;
        }


        if (newLength > currentLength) {
            setPendingNewLength(newLength);
            setExtendModalOpen(true);
            return;
        }

        if (newLength === currentLength) {
            setHeaderData(h => ({ ...h, planLength: newLength }));
            onChange(newLength);
        }
    };

    return (
        <div className="flex-1" {...props}>
            <label className="block text-sm font-medium text-gray-700 mb-1">Length</label>
            <div className="flex items-stretch border border-gray-300 rounded-lg overflow-hidden w-full">
                <button
                    type="button"
                    onClick={() => manualChangeWeeks(value - 1)}
                    disabled={disabled || plan?.weeks?.length === (isTemplate ? 0 : !programId ? 0 : parseInt(localStorage.getItem("maxDisabledWeek") || 0))}
                    className="px-3 flex items-center justify-center text-lg font-bold bg-gray-100 hover:bg-gray-200 border-r border-gray-300 disabled:opacity-[0.5] disabled:cursor-[not-allowed]"
                >
                    −
                </button>
                <input
                    type="number"
                    min="1"
                    value={tempLength}
                    onChange={(e) => setTempLength(e.target.value)}
                    onBlur={(e) => manualChangeWeeks(parseInt(e.target.value))}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.target.blur();
                        };
                    }}
                    disabled={disabled}
                    className="w-full text-center px-2 py-2 outline-none appearance-none 
                    [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none  disabled:opacity-[0.5] disabled:cursor-[not-allowed]"
                />
                <button
                    type="button"
                    onClick={() => manualChangeWeeks(value + 1)}
                    disabled={disabled}
                    className="px-3 flex items-center justify-center text-lg font-bold bg-gray-100 hover:bg-gray-200 border-l border-gray-300  disabled:opacity-[0.5] disabled:cursor-[not-allowed]"
                >
                    +
                </button>
            </div>

            {showDialog && (
                <ConfirmWeekDialog
                    onCancel={handleCancel}
                    onConfirm={handleConfirm}
                    title={dialogType === "block" ? "Unable to Delete Week(s)" : "Delete Week(s)?"}
                    message={
                        dialogType === "block"
                            ? "This contains week(s) that has tasks that were completed or scheduled in the past. It cannot be deleted."
                            : "This has week(s) that contains some tasks. Are you sure you want to delete it?"
                    }
                    confirmLabel={dialogType === "block" ? "Delete weeks(s) till possible" : "Yes, Delete Week(s)"}
                />
            )}

            {extendModalOpen && (
                <ConfirmDialog
                    onCancel={() => setExtendModalOpen(false)}
                    onConfirm={confirmExtendPlan}
                    title="Extend Plan Duration?"
                    message="This action will increase the total plan length. Do you want to continue?"
                    confirmLabel="Yes, Extend Plan"
                />
            )}



            {deleteModalOpen && (
                <ConfirmWeekDialog
                    onCancel={() => setDeleteModalOpen(false)}
                    onConfirm={confirmReducePlan}
                    title="Delete Week(s)?"
                    message="Are you sure you want to delete selected week(s)? This will remove all days in selected week(s) and cannot be undone."
                    confirmLabel="Yes, Delete Week(s)"
                />
            )}
        </div>
    );
}
